module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-16.42dd24a3.png";